// extracted by mini-css-extract-plugin
export default {"category-wrapper":"category-wrapper--mp-ktyH4","categoryWrapper":"category-wrapper--mp-ktyH4","category-name":"category-name--mp-tqPO9","categoryName":"category-name--mp-tqPO9"};